import { CreatePatientComorbidityDTO } from '../../domain/models/PatientComorbidities'
import { UpdatePatientProfileMedicalRecord } from '../../domain/models/UpdatePatientProfileMedicalRecord'
import { MedicalSheetRepository } from '../../domain/repositories/MedicalSheetRepository'
import { MedicalSheetDatasource } from '../datasources/MedicalRecordDatasource'

export const medicalSheetRepositoryAdapter = (
  medicalSheetDatasource: MedicalSheetDatasource
): MedicalSheetRepository => {
  return {
    getProfilePatientMedicalRecord: async (patientId: string) => {
      return await medicalSheetDatasource.getProfilePatientMedicalRecord(
        patientId
      )
    },
    updateProfilePatientMedicalRecord: async (
      patientId: string,
      data: UpdatePatientProfileMedicalRecord
    ) => {
      return await medicalSheetDatasource.updateProfilePatientMedicalRecord(
        patientId,
        data
      )
    },
    getAllergyPatientMedicalRecord: async (patientId: string) => {
      return await medicalSheetDatasource.getAllergyPatientMedicalRecord(
        patientId
      )
    },
    getFullPrescriptionMedicalRecord: async (patientId: string) => {
      return await medicalSheetDatasource.getFullPrescriptionMedicalRecord(
        patientId
      )
    },
    deleteAllergyPatientMedicalRecord: async (patientAllergyId: string) => {
      return await medicalSheetDatasource.deleteAllergyPatientMedicalRecord(
        patientAllergyId
      )
    },
    createAllergyPatientMedicalRecord: async (patientId, data) => {
      return await medicalSheetDatasource.createAllergyPatientMedicalRecord(
        patientId,
        data
      )
    },
    remediesHomePatientMedicalRecord: async (patientId: string) => {
      return await medicalSheetDatasource.remediesHomePatientMedicalRecord(
        patientId
      )
    },
    createRemediesHomePatientMedicalRecord: async (patientId, data) => {
      return await medicalSheetDatasource.createRemediesHomePatientMedicalRecord(
        patientId,
        data
      )
    },
    drugAllergies: async (patientId: string) => {
      return await medicalSheetDatasource.drugAllergies(patientId)
    },
    deleteDrugAllergies: async (patientId: string) => {
      return await medicalSheetDatasource.deleteDrugAllergies(patientId)
    },
    deleteRemedieHome: async (remedyId: string) => {
      return await medicalSheetDatasource.deleteRemedieHome(remedyId)
    },
    async getPatientComorbidities(patientId: string) {
      return await medicalSheetDatasource.getPatientComorbidities(patientId)
    },
    async createPatientComorbidity(
      patientId: string,
      data: CreatePatientComorbidityDTO
    ) {
      return await medicalSheetDatasource.createPatientComorbidity(
        patientId,
        data
      )
    },
    async deletePatientComorbidity(comorbidityId: string) {
      return await medicalSheetDatasource.deletePatientComorbidity(
        comorbidityId
      )
    }
  }
}
